export default "__VITE_ASSET__BsOa$FXY__"